var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "LayoutWrapper",
    { attrs: { id: _vm.id } },
    [
      _c(
        "LayoutPaddingSpace",
        [
          _c("SequenceTypeBlock"),
          _c(
            "LayoutContainer",
            [
              _c(
                "LayoutColumn",
                [
                  _c("SectionTitle", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Search.labels.searchParameters")) +
                        " "
                    ),
                  ]),
                  _c(
                    "SectionBlock",
                    [
                      _c("SubjectLengthField"),
                      _c("AlignmentIdentityField"),
                      _c("QueryIdentityField"),
                      _c("QueryCoverageField"),
                      _c("SubjectIdentityField"),
                      _c("SubjectCoverageField"),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "LayoutColumn",
                [
                  _c("SectionTitle", [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("Search.labels.algorithmSettings")) +
                        " "
                    ),
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "SectionBlock",
                        [
                          _c("MatchWithGapsField"),
                          _c("EvalueField"),
                          _c("LowComplexRegionField"),
                        ],
                        1
                      ),
                      !_vm.store.algorithmSettingsDisabled
                        ? _c("AlgorithmBlock")
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("ResetSection", {
        attrs: { "show-apply-to-all": _vm.showApplyToAll },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }